import { render } from "./BreadcrumbNav.vue?vue&type=template&id=73440480&scoped=true"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js"

import "./BreadcrumbNav.vue?vue&type=style&index=0&id=73440480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73440480"]])

export default __exports__